import axios from 'axios';
import { isIE9 } from './tool';
import { requestUrl } from '@/config/app';
import { createSessionExpiredError, notifySessionExpired } from './session';

axios.defaults.withCredentials = true;

axios.defaults.crossDomain = true;

axios.defaults.baseURL = requestUrl;

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

axios.interceptors.response.use(
  function (response) {
    //判断是否有是ie9
    if (isIE9()) {
      //特殊处理response
      if (response.status == 200 && response.request) {
        if (
          response.request.responseType === 'json' &&
          response.request.responseText
        ) {
          response.data = JSON.parse(response.request.responseText);
          console.log('repsonse', response);
        }
      }
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

function isPublicSessionRequest(url) {
  const path = String(url).split(/[?#]/)[0].replace(/\/+$/, '');
  return /(?:^|\/)(?:login|login_check|send_smscode|logout)$/.test(path);
}

function withSession(url, send) {
  const token = window.localStorage.getItem('token') || '';
  return Promise.resolve()
    .then(() => send(token))
    .then((response) => {
      if (response.data.code == 1) return response.data.result;
      if (Number(response.data.code) === 401) {
        const error = new Error(response.data.message || '登录会话已失效，请重新登录');
        error.status = 401;
        error.response = response;
        throw error;
      }
      throw response.data.message;
    })
    .catch((error) => {
      const response = error && error.response;
      const message = response && response.data && response.data.message;
      const status = (error && error.status) || (response && response.status);
      if (Number(status) === 401 && !isPublicSessionRequest(url)) {
        const expired = createSessionExpiredError(message || (error && error.message));
        // The registered handler clears the current token synchronously. Later
        // failures from this session, or from an older login, cannot clear a new one.
        if (token && token === window.localStorage.getItem('token')) {
          notifySessionExpired({ token, message: expired.message });
        }
        throw expired;
      }
      throw message || error;
    });
}

export function get(url, params = {}) {
  return withSession(url, (token) => axios.get(url, {
    params: { ...params, time: new Date().getTime() },
    headers: { Authorization: `Bearer ${token}` },
  }));
}

export function post(url, data = {}) {
  return withSession(url, (token) => axios.post(url, data, {
    headers: { Authorization: `Bearer ${token}` },
  }));
}

const upvideoconfig = axios.create({
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export function uploadfile(url, data) {
  return withSession(url, (token) => upvideoconfig.post(url, data, {
    headers: { Authorization: `Bearer ${token}` },
  }));
}
